const isProduction = process.env.NODE_ENV === 'production';

let config;
if (isProduction) {
    config = require('./config/production');
} else {
    config = require('./config/development');
}

export default config;